import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {alabaster} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    marginTop: 20,
  },
  listItem: {},
  listItemWithBorder: {
    borderRadius: 8,
    backgroundColor: alabaster,
    marginBottom: indent * 0.4,
    paddingLeft: indent,
    paddingRight: indent * 0.35,
  },
});
